import React, { useState } from 'react'
import ProvinceListing from '../../components/province/ProvinceListing'
import CreateProvince from '../../components/province/CreateProvince'
import ReusableModal from '../../components/reusable/OpenModal'

const Province = () => {
   const [isModalOpen, setIsModalOpen] = useState(false)
   const openModal = () => setIsModalOpen(true)
   const closeModal = () => setIsModalOpen(false)
 
   return (
       <div className="container mt-4">
            {/* Header Section with Add Button */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>Province Management</h2>
                <button 
                    className="btn btn-primary" 
                    onClick={openModal}
                >
                    <i className="bi bi-plus-circle me-2"></i> 
                    Add New Province
                </button>
            </div>

            {/* Listing Component */}
            <ProvinceListing />

            {/* Reusable Modal Wrapper */}
            <ReusableModal 
                isOpen={isModalOpen} 
                onClose={closeModal} 
                title="Create New Province Configuration"
            >
             <CreateProvince onFormSuccess={closeModal} />
            </ReusableModal>       
    </div>
  )
}

export default Province
